import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfferDetailALV1Component } from './offer-detail-al-v1/offer-detail-al-v1.component';



@NgModule({
  declarations: [OfferDetailALV1Component],
  exports: [
    OfferDetailALV1Component,
  ],
  imports: [
    CommonModule
  ],
  providers: [
    OfferDetailALV1Component,
  ]
})
export class OfferDetailModule { }
